import React, { useState, useRef, useEffect } from 'react';
import { FiLogOut } from 'react-icons/fi';
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import logo from "./../../../assets/audit_assets/Audit_navbar/logo.png"; 
import { RiLockPasswordFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import "./AuditNavBar.css";
import { useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { getUserRole } from "./../../../services/global_redux/globale_actions/Role.action"
import {  uploadUserProfile, getUserProfile, deleteUserProfile } from "../../../services/global_redux/globale_actions/Login.action";
import { GoChevronDown } from "react-icons/go";
import { GoChevronUp } from "react-icons/go";
import { FaUser } from "react-icons/fa";
import { getCompanyDetails} from "./../../../services/global_redux/globale_actions/CompanyDetails.action"
import NotificationBell from "../../global/navbar/NotificationBell";

const PROFILE_ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];
const PROFILE_ALLOWED_EXT = [".jpg", ".jpeg", ".png"];

function DefaultProfileAvatar({ size = 36, className = "" }) {
  return (
    <span
      className={`nav-default-avatar ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <FaUser />
    </span>
  );
}

function ProfileImage({ src, size = 36, className = "", onClick, alt = "Profile" }) {
  if (src) {
    return (
      <img
        className={className || "nav-profile-avatar"}
        src={src}
        alt={alt}
        onClick={onClick}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover",
          border: "1px solid #dbe7ff",
          background: "#f0f5ff",
          cursor: onClick ? "pointer" : undefined,
        }}
      />
    );
  }
  const avatar = <DefaultProfileAvatar size={size} className={className} />;
  if (!onClick) return avatar;
  return (
    <button
      type="button"
      className="nav-default-avatar-btn"
      onClick={onClick}
      aria-label={alt}
      style={{ width: size, height: size }}
    >
      {avatar}
    </button>
  );
}

function AuditNavBar({ showSnackbar,onSearch }) {
  const profileRef = useRef(null);
  const navRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openlogout, setOpenlogout] = useState(false);
    const [permissionsSections, setPermissionsSections] = useState(null);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(null);
    const [userProfileUrl, setUserProfileUrl] = useState(null);
    const [openRemoveProfile, setOpenRemoveProfile] = useState(false);
    const [sliderStyle, setSliderStyle] = useState({});
    const loggedInUser = JSON.parse(sessionStorage.getItem('user'))?.user_name;
    const loggedInrole = JSON.parse(sessionStorage.getItem('user'))?.role_name;
    const loggedInBaseRole = JSON.parse(sessionStorage.getItem('user'))?.base_role;
    const [currentCompany, setCurrentCompany] = useState(
      JSON.parse(sessionStorage.getItem('user'))?.company_code
    );
    const [companyServices, setCompanyServices] = useState([]);    
    const hasAuditAccess = companyServices.includes("Audit");
    const hasRegisterAccess = companyServices.includes("Registers");

    const registerRef = useRef(null);
    const auditRef = useRef(null);
    const fileInputRef = useRef(null);
    const handleClickOpenlogout = () => {
        setOpenlogout(true);
    };
    const handleCloselogout = () => {
        setOpenlogout(false);
    };
    const modelToggleChangedata = (data) => {
      moveSlider(data);
      if(sessionStorage.getItem('activeTab') !== data){
        setActiveTab(data);
        sessionStorage.setItem("activeTab", data);
        window.location.href = '/dashboard';
      }
    };
    const modelToggleChange = (tabName) => {
      if (tabName === "Audit" && !hasAuditAccess ) {
        showSnackbar("You don't have access for Audit", "warning");
        return;
      }
    
      if (tabName === "Registers" && !hasRegisterAccess ) {
        showSnackbar("You don't have access for Registers", "warning");
        return;
      }
      modelToggleChangedata(tabName);
    };
    
    const currentPath = window.location.pathname;
    const navItems = [
      { title: "Dashboard", link: "/dashboard" },
      {
        title: "Audit",
        children: [
          { title: "Vendor", link: "/audit-vendor" },
          { title: "Create Audit", link: "/create-audit" },
          { title: "Audit Details", link: "/audit-details" }
        ],
      },
      { title: "Report", link: "/audit-report" },
      {
        title: "Configuration",
        children: [
          {
            title: "User & Role Management",
            children: [
              { title: "Create Role", link: "/configuration/user-role-management/role" },
              { title: "Assign Permissions", link: "/configuration/user-role-management/role-permission" },
              { title: "Create Users", link: "/configuration/user-role-management/users" },
              { title: "Assign Client", link: "/configuration/user-role-management/users-client" },
            ],
          },
          { title: "Org Details", link: "/configuration/org-details" },
          { title: "Template Mapping", link: "/configuration/template-mapping" },
          {
            title: "Developer Setting",
            children: [
              { title: "Access Configuration", link: "/configuration/developer-settings/access-configuration" },
              { title: "States", link: "/configuration/developer-settings/configuration/states" },
            ],
          },
        ],
      },
    ];

    useEffect(() => {
      const handleOutsideClick = (e) => {
        if (navRef.current && !navRef.current.contains(e.target)) {
          document
            .querySelectorAll(".dropdown-menu.show")
            .forEach((menu) => menu.classList.remove("show"));
        }
      };
    
      document.addEventListener("click", handleOutsideClick);
    
      return () => {
        document.removeEventListener("click", handleOutsideClick);
      };
    }, []);
    
    const vendorNavItems = [
      { title: "Dashboard", link: "/dashboard" },
      { title: "Audits", link: "vendor/Audit" },
      ];
      const renderNavItems = (items, level = 0) => {
        return items.map((item, index) => {
          if (item.children) {
            return (
              <li
                key={`${item.title}-${index}`}
                className={`nav-item dropdown position-relative ${level > 0 ? "dropdown-submenu" : ""}`}
              >
                {/* <a
                  className={`nav-link dropdown-toggle text-white fw-semibold ${item.isActive ? "activeNav" : ""}`}
                  href="#"
                  id={`${item.title.toLowerCase().replace(/\s+/g, "")}-dropdown-${index}`}
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                > */}
                <a
                  className={`nav-link dropdown-toggle text-white fw-semibold ${
                    item.isActive ? "activeNav" : ""
                  }`}
                  href="#"
                  id={`${item.title.toLowerCase().replace(/\s+/g, "")}-dropdown-${index}`}
                  role="button"
                  aria-expanded="false"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const submenu = e.currentTarget.nextSibling;

                    // Close other open submenus
                    document
                      .querySelectorAll(".dropdown-submenu .dropdown-menu.show")
                      .forEach((menu) => {
                        if (menu !== submenu) {
                          menu.classList.remove("show");
                        }
                      });

                    // Toggle current submenu
                    submenu.classList.toggle("show");
                  }}
                >


                  {item.title}
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-dark"
                  aria-labelledby={`${item.title.toLowerCase().replace(/\s+/g, "")}-dropdown-${index}`}
                >
                  {renderNavItems(item.children, level + 1)}
                </ul>
              </li>
            );
          }
          return (
            <li key={`${item.title}-${index}`}>
              <NavLink
                to={item.link}
                className={({ isActive }) =>
                  `nav-link fw-semibold text-white ${isActive ? "activeNav" : ""}`
                }
                onClick={closeDropdown}
              >
                {item.title}
              </NavLink>
            </li>
          );
        });
      };
      
      const moveSlider = (datacheck) => {
        const activeRef = datacheck === "Registers" ? registerRef : auditRef;
    
        if (activeRef?.current) {
          setSliderStyle({
            width: activeRef.current.offsetWidth + "px",
            transform: `translateX(${activeRef.current.offsetLeft}px)`,
          });
        }
      };
    useEffect(() => {
      moveSlider(activeTab);
    }, [setActiveTab]);
    
    useEffect(() => {
      const savedTab = sessionStorage.getItem('activeTab') || "Registers";
      setActiveTab(savedTab);
      moveSlider(savedTab);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('dashboardAlertShown');
        sessionStorage.removeItem('selectedClient');
        sessionStorage.removeItem('selectedAudit');
      if (currentPath.startsWith('/vendor')) {
          navigate('/vendor/login');
      } else {
          navigate('/login');
      }
        window.location.reload();
    };


        const getUserPermission = async () => {
            try {
                const response = await dispatch(getUserRole());
                setPermissionsSections(response.data);
            } catch (err) {
                console.error("Failed to fetch states:", err);
            }
        };
        useEffect(() => {
            getUserPermission();
        }, [dispatch]);
    
        useEffect(() => {
            const dropdownToggles = document.querySelectorAll('.dropdown-submenu .dropdown-toggle');

            dropdownToggles.forEach((element) => {
                element.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.nextElementSibling.classList.toggle('show');
                });
            });

            return () => {
                dropdownToggles.forEach((element) => {
                    element.removeEventListener('click', () => { });
                });
            };
        }, []);
        useEffect(() => {
            const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setIsProfileOpen(false);
            }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }, []);
      
        const profileUser = async () => {
            try{
            const response = await dispatch(getUserProfile());
            const url = response?.success ? (response.data?.data || response.data?.profile) : null;
            if (url && typeof url === "string" && url !== "null" && !url.includes("undefined")) {
                setUserProfileUrl(`${url}?t=${Date.now()}`);
            } else {
                setUserProfileUrl(null);
            }
            } catch(err){
            console.error("error",err);
            setUserProfileUrl(null);
            }
            
        }
        useEffect(() => {
            profileUser();
        }, [dispatch]);

  const handleImageClick = () => {
    if (loggedInBaseRole === "vendor") return;
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    const name = (file.name || "").toLowerCase();
    const extOk = PROFILE_ALLOWED_EXT.some((ext) => name.endsWith(ext));
    const typeOk = !file.type || PROFILE_ALLOWED_TYPES.includes(file.type.toLowerCase());
    if (!extOk || !typeOk) {
      showSnackbar?.("You can only upload image JPG or PNG", "error");
      return;
    }
    uploadUserImg(file);
  };

  const uploadUserImg = async (file) =>{
    try{
      const response = await dispatch(uploadUserProfile(file));
      if(response.success === true){
          setUserProfileUrl(`${response.data}?t=${Date.now()}`);
          showSnackbar?.("Profile photo updated", "success");
      } else {
          showSnackbar?.(response.message || "You can only upload image JPG or PNG", "error");
      }
    } catch(err){
      console.error("error",err)
      showSnackbar?.("You can only upload image JPG or PNG", "error");
    }
  }

  const profileImgSrc = userProfileUrl || null;

  const handleRemoveProfile = async () => {
    try {
      const response = await dispatch(deleteUserProfile());
      if (response.success === true) {
        setUserProfileUrl(null);
        setOpenRemoveProfile(false);
        showSnackbar?.("Profile photo removed", "success");
      } else {
        showSnackbar?.(response.message || "Failed to remove profile", "error");
      }
    } catch (err) {
      console.error("error", err);
      showSnackbar?.("Failed to remove profile", "error");
    }
  };  
  const handleSearchChange = (e) => {
    onSearch(e.target.value);
  };

    // chatgptprompt 
    const closeDropdown = () => {
        const toggle = document.getElementById("auditDropdown");
        if (!toggle) return;
    
        const menu = toggle.nextElementSibling;
    
        document
        .querySelectorAll(".dropdown-menu.show")
        .forEach((menu) => menu.classList.remove("show"));
        try {
          if (typeof window !== "undefined" && window.bootstrap && window.bootstrap.Dropdown) {
            let instance = window.bootstrap.Dropdown.getInstance(toggle);
            if (!instance) instance = new window.bootstrap.Dropdown(toggle);
            instance.hide();
            return;
          }
        } catch (err) {
        }
        try {
          if (menu && menu.classList.contains("show")) menu.classList.remove("show");
          toggle.classList.remove("show");
          toggle.setAttribute("aria-expanded", "false");
          const parent = toggle.closest(".dropdown");
          if (parent && parent.classList.contains("show")) parent.classList.remove("show");
    
          toggle.blur();
        } catch (err) {
          document.body.click();
        }
      };
      const formatValidPermissions = (permissions) => {
        const result = {};
        if (permissions && typeof permissions[0] === "string") {
          try {
            permissions = JSON.parse(permissions[0]);
          } catch (e) {
            console.error("Invalid permission JSON", e);
            return result;
          }
        }
        if (permissions) {
          permissions.forEach(({ section, module, sub_module }) => {
            if (!section || !module) return;
            if (Array.isArray(sub_module)) {
              const validSubModules = sub_module.filter((sub) => sub && sub.name);
              if (!result[section]) result[section] = {};
              result[section][module] =
                validSubModules.length > 0
                  ? validSubModules.map((sub) => sub.name)
                  : sub_module.map((sub) => sub.name);
            } else {
              if (!result[section]) result[section] = {};
              result[section][module] = [];
            }
          });
        }
        return result;
      };
  const permissionMap = permissionsSections
  ? formatValidPermissions(permissionsSections.permissions)
  : null;

  const filterMenuByPermission = (items, permissions) => {
    if (!permissions || typeof permissions !== "object") {
      permissions = {};
    }
  
    return items
      .map((item) => {
        if (["Dashboard","Report"].includes(item.title)) {
          return item;
        }
  
        if (item.children) {
          const permForItem = permissions[item.title];
  
          if (Array.isArray(permForItem)) {
            if (permForItem.length === 0) {
              return { ...item, children: [] };
            }
            const allowedChildren = item.children.filter((child) =>
              permForItem.includes(child.title)
            );
            if (allowedChildren.length > 0) {
              return { ...item, children: allowedChildren };
            }
            return null;
          }
  
          if (typeof permForItem === "object" && permForItem !== null) {
            const filteredChildren = filterMenuByPermission(
              item.children,
              permForItem
            );
            if (filteredChildren.length > 0) {
              return { ...item, children: filteredChildren };
            }
  
            if (permissions.hasOwnProperty(item.title)) {
              return { ...item, children: [] };
            }
            return null;
          }
  
          return null;
        }
  
        const perm = permissions[item.title];
  
        if (Array.isArray(perm)) {
          return item;
        }
  
        if (typeof perm === "object" && perm !== null) {
          return item;
        }
  
        return null;
      })
      .filter(Boolean);
  };
  
  const getCompanyDetailbyid = async () => {
    try {
      const response = await dispatch(getCompanyDetails(currentCompany));
  
      if (response.success === true) {
        setCompanyServices(response.data.services);
      }
    } catch (err) {
      console.error("Failed to fetch company details:", err);
    }
  };
  
  useEffect(() => { 
    if (currentCompany) {
      getCompanyDetailbyid();
    }
  }, [currentCompany]);
      
  const filteredMenuItems = filterMenuByPermission(navItems, permissionMap);
  const menuForUser = (() => {
    if (loggedInBaseRole !== "Client") return filteredMenuItems;
    const trackItem = { title: "Track Audit", link: "/track-audit" };
    const reportIndex = filteredMenuItems.findIndex((item) => item.title === "Report");
    if (reportIndex < 0) return [...filteredMenuItems, trackItem];
    return [
      ...filteredMenuItems.slice(0, reportIndex + 1),
      trackItem,
      ...filteredMenuItems.slice(reportIndex + 1),
    ];
  })();
    return (
      <div className="row">
        <div className='col-md-12 navbarcolor'>
            <div className="navbarcolorData">
                
            </div>
        </div>
            <nav className="navbar navbar-expand-md bg-transparent p-0 m-0 navbarmainAudit">
            <div className="container-fluid py-1 mx-3 mt-3 d-flex justify-content-between align-items-center">
            
                <div className="d-flex align-items-center gap-0">
                <a
                    className={`navbar-brand m-0 logo-open-nav`}
                    href="/dashboard"
                >
                    <img
                    className="company-logo-manu-Audit"
                    src={logo}
                    alt="Logo"
                    />
                </a>
                </div>
                <div className="d-flex align-items-center gap-4 flex-wrap justify-content-end flex-grow-1 navdatas">

                <ul ref={navRef} className="navbar-nav d-flex align-items-end gap-3 mx-auto middle-nav-links" id='auditDropdown'>
                    {loggedInBaseRole === "vendor" ? renderNavItems(vendorNavItems):renderNavItems(menuForUser)}
                    </ul>
                </div>

                <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end">
            
                <div className="search-box search-box-nav-bar position-relative flex-shrink-0">
                    <input
                    type="text"
                    className="form-control ps-5 text-white"
                    placeholder="Search here..."
                    onChange={handleSearchChange}
                    />
                    <i
                    className="bi bi-search position-absolute"
                    style={{
                        top: "50%",
                        left: "15px",
                        transform: "translateY(-50%)",
                        color: "#fff"
                    }}
                    ></i>
                </div>
                {loggedInBaseRole !== "vendor" && 
                <div className='register-audit-group-main'>
                  <div className="register-audit-group position-relative bg-primary">

                    {/* slider */}
                    <div
                      className="slider bg-white position-absolute top-0 start-0 h-100 rounded-pill border-none"
                      style={sliderStyle}
                    ></div>

                    {/* Register Button Always Visible */}
                    <button
                      ref={registerRef}
                      className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                        activeTab === "Registers" ? "text-primary" : "text-white"
                      }`}
                      onClick={() => modelToggleChange("Registers")}
                    >
                      Register
                    </button>

                    {/* Audit Button – only if user has access */}
                    {hasAuditAccess ? (
                      <button
                        ref={auditRef}
                        className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                          activeTab === "Audit" ? "text-primary bg-white" : "text-white"
                        }`}
                        onClick={() => modelToggleChange("Audit")}
                      >
                        Audit
                      </button>
                    ) : null}
                  </div>
                </div>

                }

                <NotificationBell service="Audit" />

            <div className="nav-item dropdown me-3" ref={profileRef} style={{ position: "relative" }}>
            <div
                className="d-flex align-items-center gap-2 useIPmain"
                onClick={() => setIsProfileOpen((prev) => !prev)}
                style={{ cursor: "pointer" }}
            >
                <ProfileImage src={profileImgSrc} size={36} className="nav-profile-avatar" />

                <div className="d-flex flex-column profileName">
                <span className="fw-bold">{loggedInUser || "User"}</span>
                <small className="text-muted">{loggedInrole}</small>
                </div>
                <i className="text-white">
                {isProfileOpen ? <GoChevronUp /> :<GoChevronDown />}
                
                </i>
            </div>

            {isProfileOpen && (
                <ul
                className="dropdown-menu dropdown-menu-end show navDropdownDatas"
                style={{ position: "absolute", top: "100%", right: 0, display: "block" }}
                >
                <p className="text-center mb-0">
                    <ProfileImage
                    src={profileImgSrc}
                    size={50}
                    className="nav-profile-avatar-lg"
                    onClick={loggedInBaseRole !== "vendor" ? handleImageClick : undefined}
                    />
                    <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                    />
                </p>
                <p className="text-center dataName">{loggedInUser || "User"}</p>
                <p className="text-center dataRole">{loggedInrole}</p>
                {userProfileUrl && loggedInBaseRole !== "vendor" ? (
                  <p className="text-center mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenRemoveProfile(true);
                      }}
                    >
                      Remove profile
                    </button>
                  </p>
                ) : null}
                <hr />

                <li className='datali'>
                    <a className="dropdown-item" href="/reset_password">
                    <FiLogOut /> Change Password
                    </a>
                </li>
                <li className='datali'>
                    <a  className="dropdown-item " href='#' onClick={handleClickOpenlogout}>
                    <RiLockPasswordFill /> Logout
                    </a>
                </li>
                </ul>
            )}
            </div>


                </div>
            </div>
                <React.Fragment>
                <Dialog
                    open={openlogout}
                    onClose={handleCloselogout}
                    handleLogout={handleLogout}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Logout ?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to logout?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloselogout}>Cancel</Button>
                        <Button onClick={handleLogout} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openRemoveProfile}
                    onClose={() => setOpenRemoveProfile(false)}
                    aria-labelledby="remove-profile-title"
                >
                    <DialogTitle id="remove-profile-title">
                        Remove profile?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to remove your profile photo?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenRemoveProfile(false)}>Cancel</Button>
                        <Button onClick={handleRemoveProfile} autoFocus color="error">
                            Yes, remove
                        </Button>
                    </DialogActions>
                </Dialog>
                </React.Fragment>

            </nav>
            <nav className="navbar navbar-expand-lg mobilenavbarAudit sticky-top">
              <div className="container-fluid">
                <NavLink className="navbar-brand d-flex align-items-center" to="/">
                  <img
                    src={logo} 
                    alt="Logo"
                    height="35"
                    className="me-2"
                  />
                </NavLink>
                <button
                  className="navbar-toggler border-white"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#mainNavbar"
                  aria-controls="mainNavbar"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse " id="mainNavbar">
                  <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li className='text-center'>
                      {loggedInBaseRole !== "vendor" && 
                        // <div className='register-audit-group-main'>
                        //     <div className="register-audit-group position-relative  bg-primary">
                        //         <div
                        //         className="slider bg-white position-absolute top-0 start-0 h-100 rounded-pill  border-none"
                        //         style={sliderStyle}
                        //         ></div>
                        
                        //         <button
                        //         ref={registerRef}
                        //         type="button"
                        //         className={` fw-medium border-none rounded-pill btn-sm p-0 m-0 ${
                        //             activeTab === "Registers" ? "text-primary" : "text-white "
                        //         }`}
                        //         style={{ maxWidth:"250px" }}
                        //         onClick={() => modelToggleChange("Registers")}
                        //         >
                        //         Register
                        //         </button>
                        
                        //         <button
                        //         ref={auditRef}
                        //         type="button"
                        //         className={` fw-medium border-none rounded-pill btn-sm p-0 m-0 ${
                        //             activeTab === "Audit" ? "text-primary" : "text-white "
                        //         }`}
                        //         style={{ maxWidth:"250px" }}
                        //         onClick={() => modelToggleChange("Audit")}
                        //         >
                        //         Audit
                        //         </button>
                        //     </div>
                        // </div>
                        
                <div className='register-audit-group-main'>
                <div className="register-audit-group position-relative bg-primary">

                  {/* slider */}
                  <div
                    className="slider bg-white position-absolute top-0 start-0 h-100 rounded-pill border-none"
                    style={sliderStyle}
                  ></div>

                  {/* Register Button Always Visible */}
                  <button
                    ref={registerRef}
                    className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                      activeTab === "Registers" ? "text-primary" : "text-white"
                    }`}
                    onClick={() => modelToggleChange("Registers")}
                  >
                    Register
                  </button>

                  {/* Audit Button – only if user has access */}
                  {hasAuditAccess ? (
                    <button
                      ref={auditRef}
                      className={`fw-medium border-none rounded-pill btn-sm px-3 py-1 m-0 ${
                        activeTab === "Audit" ? "text-primary bg-white" : "text-white"
                      }`}
                      onClick={() => modelToggleChange("Audit")}
                    >
                      Audit
                    </button>
                  ) : null}
                </div>
              </div>
                      }
                    </li>
                    <li className="w-100">
                      <ul className="navbar-nav d-flex mx-auto">
                        {loggedInBaseRole === "vendor"
                          ? renderNavItems(vendorNavItems)
                          : renderNavItems(loggedInBaseRole === "Client" ? menuForUser : navItems)}
                      </ul>
                    </li>


                    <li className="nav-item dropdown me-3">
                      <a
                        className="nav-link dropdown-toggle d-flex align-items-center gap-2 useIPmain"
                        href="#"
                        id="navbarProfileDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <ProfileImage src={profileImgSrc} size={35} />

                        <div className="d-flex flex-column profileName">
                          <span className="dataName">{loggedInUser || "User"}</span>
                          <small className="dataRole">{loggedInrole}</small>
                        </div>
                      </a>

                      <ul
                        className="dropdown-menu dropdown-menu-end navDropdownDatas"
                        aria-labelledby="navbarProfileDropdown"
                      >
                        <p className="text-center mb-0">
                          <ProfileImage
                            src={profileImgSrc}
                            size={50}
                            onClick={loggedInBaseRole !== "vendor" ? handleImageClick : undefined}
                          />
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                          />
                        </p>
                        <p className="text-center dataName">{loggedInUser || "User"}</p>
                        <p className="text-center dataRole">{loggedInrole}</p>
                        {userProfileUrl && loggedInBaseRole !== "vendor" ? (
                          <p className="text-center mb-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={(e) => {
                                e.preventDefault();
                                setOpenRemoveProfile(true);
                              }}
                            >
                              Remove profile
                            </button>
                          </p>
                        ) : null}
                        <hr />

                        {/* <li className="datali">
                          <a className="dropdown-item" href="/reset_password" onClick={handleChangePassword}>
                            <FiLogOut /> Change Password
                          </a>
                        </li> */}
                        <li className="datali">
                          <a className="dropdown-item" href="#" onClick={handleClickOpenlogout}>
                            <RiLockPasswordFill /> Logout
                          </a>
                        </li>
                      </ul>
                    </li>

                  </ul>
                </div>
              </div>
            </nav>
      </div>
  );
};


export default AuditNavBar;
